import { Link } from "react-router-dom";
import { CheckCircle2, Phone, MessageCircle, Home as HomeIcon } from "lucide-react";
import { Seo } from "@/components/Seo";
import { BUSINESS, telLink, whatsappLink } from "@/data/business";
import { container, btnPrimary, btnOutlineNavy } from "@/lib/ui";

export default function QuoteSuccess() {
  return (
    <div className="bg-neutralbg min-h-[80vh] grid place-items-center py-16" data-testid="quote-success">
      <Seo title="Quote Request Received" description="Thank you — we've received your cleaning quote request and will be in touch shortly." path="/quote/success" />
      <div className={`${container} max-w-2xl`}>
        <div className="rounded-3xl bg-white shadow-[0_16px_48px_rgba(15,61,94,0.10)] border border-gray-100 p-8 sm:p-12 text-center">
          <span className="inline-grid place-items-center w-20 h-20 rounded-full bg-brandgreen/10 mx-auto">
            <CheckCircle2 className="w-11 h-11 text-brandgreen" />
          </span>
          <h1 className="mt-6 font-heading text-3xl font-bold text-navy tracking-tight">Thank you!</h1>
          <p className="mt-4 text-gray-600 leading-relaxed">
            We have received your request. Our team will review the information and prepare your personalised
            quote. We may contact you for additional information or photos before confirming your booking.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row justify-center gap-4">
            <a href={telLink} className={btnOutlineNavy}>
              <Phone className="w-4 h-4" /> Call {BUSINESS.phoneDisplay}
            </a>
            <a href={whatsappLink()} target="_blank" rel="noopener noreferrer" className={btnPrimary}>
              <MessageCircle className="w-4 h-4" /> WhatsApp Us
            </a>
          </div>

          <Link to="/" className="mt-8 inline-flex items-center gap-1.5 text-sm font-semibold text-navy hover:text-brandgreen transition-colors">
            <HomeIcon className="w-4 h-4" /> Back to home
          </Link>
        </div>
      </div>
    </div>
  );
}
